import type { Point, TableEdge } from "../types";

export const DEFAULT_DM_TABLE_EDGE: TableEdge = "north";
export const DEFAULT_COVER_COLOR = "#070708";

export function normalizeCoverColor(value?: string): string {
  return typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value) ? value.toLowerCase() : DEFAULT_COVER_COLOR;
}

/** Position the folded cloth just beyond the configured DM edge. */
export function clothOffset(edge: TableEdge, aspect: number, progress: number): Point {
  const remaining = 1 - Math.max(0, Math.min(1, progress));
  const horizontal = 2.18 * Math.max(1, aspect) * remaining;
  const vertical = 2.18 * remaining;
  if (edge === "south") return { x: 0, y: -vertical };
  if (edge === "east") return { x: horizontal, y: 0 };
  if (edge === "west") return { x: -horizontal, y: 0 };
  return { x: 0, y: vertical };
}
